@if ({ vtoCategories: vtoBeautyFacade.localizedVtoCategories$ | async, selectedVtoCategory:
vtoBeautyFacade.activeCategory$ | async, selectedVtoSubcategory: vtoBeautyFacade.activeSubcategory$ | async,
displayLearnMoreLink: vtoBeautyFacade.displayLearnMoreLink$ | async }; as synced) { @if ( synced.selectedVtoCategory &&
synced.selectedVtoSubcategory && synced.vtoCategories && synced.vtoCategories.length > 0 ) {
<div class="vto-module-selector">
    <div class="vto-tabs">
        <div
            role="tablist"
            i18n-role
            id="vto-categories"
            aria-label="virtual try-on categories tablist"
            i18n-aria-label="@@hermes.product-page.vto-category-title"
            class="vto-categories">
            @for (vtoCategory of synced.vtoCategories; track vtoCategory; let i = $index) {
            <button
                #categoryButtons
                [id]="'vto-category-' + i"
                [class.selected-category]="vtoCategory.vtoCategoryType === synced.selectedVtoCategory.vtoCategoryType"
                class="vto-category-button"
                type="button"
                role="tab"
                hVtoScrollSelectAnimation
                [animationElement]="animationVto"
                [selectAnimation]="vtoCategory.vtoCategoryType === synced.selectedVtoCategory.vtoCategoryType"
                [attr.aria-controls]="'vto-subcategories'"
                [attr.aria-selected]="vtoCategory === synced.selectedVtoCategory"
                [tabindex]="vtoCategory.vtoCategoryType === synced.selectedVtoCategory.vtoCategoryType ? 0 : -1"
                (keydown)="keydownCategory($event, i, synced.vtoCategories.length - 1, 'category')"
                (click)="selectVtoCategory(vtoCategory)"
                (focus)="onCategoryFocus($event)">
                <span class="vto-category paragraph-medium">
                    {{ vtoCategory.localizedVtoCategoryType | uppercase }}</span
                >
            </button>
            }
        </div>
        <div #animationVto class="animation-vto-categories"></div>
        @if (synced.selectedVtoCategory?.vtoSubcategories) {
        <div
            role="tablist"
            id="vto-subcategories"
            i18n-role
            aria-label="virtual try-on subcategories tablist"
            i18n-aria-label="@@hermes.product-page.vto-line-title"
            class="vto-subcategories">
            @for (vtoSubcategory of synced.selectedVtoCategory.vtoSubcategories; track vtoSubcategory; let i = $index) {
            <button
                #subcategoryButtons
                [id]="'vto-subcategory-' + i"
                [class.selected-subcategory]="
                    vtoSubcategory.vtoSubcategoryType === synced.selectedVtoSubcategory.vtoSubcategoryType
                "
                hVtoScrollIntoView
                [vtoScrollIntoView]="
                    vtoSubcategory.vtoSubcategoryType === synced.selectedVtoSubcategory.vtoSubcategoryType
                "
                class="vto-subcategory-button"
                type="button"
                role="tab"
                [attr.aria-controls]="'variants-container'"
                [attr.aria-selected]="vtoSubcategory === synced.selectedVtoSubcategory"
                [tabindex]="(focusableSubcategories$ | async)?.includes(vtoSubcategory) ? 0 : -1"
                (keydown)="
                    keydownCategory($event, i, synced.selectedVtoCategory.vtoSubcategories.length - 1, 'subcategory')
                "
                (click)="selectVtoSubcategory(vtoSubcategory)"
                (focus)="onCategoryFocus($event)">
                <span class="vto-subcategory label-medium-bold-uppercase">
                    {{ vtoSubcategory.localizedVtoSubcategoryType | uppercase }}
                </span>
            </button>
            }
        </div>
        } @if (synced.selectedVtoSubcategory) {

        <h-virtual-try-on-variants
            id="variants-container"
            role="tabpanel"
            (selectVtoVariant)="selectVtoVariant($event)"
            [selectedVtoSubcategory]="synced.selectedVtoSubcategory"></h-virtual-try-on-variants>
        <h-virtual-try-on-add-to-cart
            [activeCategoryType]="synced.selectedVtoCategory.vtoCategoryType"
            [activeSubcategoryType]="synced.selectedVtoSubcategory.vtoSubcategoryType">
        </h-virtual-try-on-add-to-cart>
        @if (synced.displayLearnMoreLink === true) {
        <div class="learn-more-link">
            <a
                [routerLink]="[]"
                class="paragraph-medium"
                i18n="@@hermes.product-page.vto-learn-more"
                id="vto-learn-more-link"
                (click)="learnMoreClick(synced.selectedVtoCategory, synced.selectedVtoSubcategory)">
                {{ "See product" }}
            </a>
        </div>
        } }
    </div>
</div>
} }
